import React from 'react';
import { useP } from '../../i18n/useP';
import { Sparkline } from './charts';
import { fmtKpiValue, unitLabel } from './cockpitCfoModel';

/* Carte KPI répétée. Mode normal = valeur + delta + sparkline (clic → drawer).
   Mode édition = interrupteur afficher/masquer.
   Charte People : carte blanche, statut porté par le seul badge ; sparkline en
   ardoise ; delta en tokens --color-delta-*. */
const STATUS_LABEL = { favorable: 'Favorable', attention: 'À surveiller', critique: 'Alerte' };

export default function KpiCard({ kpi, unit, active, editMode, hidden, onClick }) {
  const p = useP();
  const on = !hidden;
  const rateTxt = kpi.mode === 'rate' && kpi.rateVal != null
    ? `${kpi.rateVal.toFixed(1)}% ${p('du CA net')}` : null;
  const deltaCls = kpi.status === 'favorable' ? ' is-fav' : kpi.status === 'critique' ? ' is-alert' : '';
  const cls = [
    'ckc', `ckpit__st--${kpi.status}`,
    active ? 'is-active' : '',
    editMode && !on ? 'is-dim' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={cls} onClick={onClick} role="button" tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
      <div className="ckc__top">
        <div>
          <div className="ckc__label">{kpi.label}</div>
          {kpi.sublabel && <div className="ckc__sublabel">{kpi.sublabel}</div>}
        </div>
        <span className="ckc__badge">{p(STATUS_LABEL[kpi.status])}</span>
      </div>
      <div className="ckc__valrow">
        <span className="ckc__value">{fmtKpiValue(kpi, unit)}</span>
        {kpi.type !== 'mois' && !kpi.valueOverride && <span className="ckc__unit">{unitLabel(kpi, unit)}</span>}
        {rateTxt && <span className="ckc__rate">{rateTxt}</span>}
      </div>
      <div className="ckc__sub">{kpi.subOverride || kpi.subText || ''}</div>

      {!editMode && (
        <div className="ckc__foot">
          <span className={`ckc__delta${deltaCls}`}>{kpi.delta}</span>
          {kpi.trend && <Sparkline data={kpi.trend} color="var(--color-accent)" />}
        </div>
      )}
      {editMode && (
        <div className="ckc__switchrow">
          <span className={`ckc__switch-lbl ${on ? 'on' : 'off'}`}>{on ? p('Affiché') : p('Masqué')}</span>
          <span className={`ckc__switch ${on ? 'on' : ''}`}><span className="ckc__knob" /></span>
        </div>
      )}
    </div>
  );
}
